import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import {FieldArray, FormikProvider, useFormik} from 'formik';
import { useNavigate, useLocation} from 'react-router-dom'
import {registerWithEmail} from '../../../firebase/firebase'
import firebase from '../../../firebase/firebase'
import {useIntl} from 'react-intl'
import Spinner from "../../../components/spinner";
import Stepper from "../../../components/stepper";
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import ScrollToTop from '../../../utils/scrollTop';



export default function AboutYourWorkComponent(){
  const [loading, setLoading] = React.useState(false)

  const navigator = useNavigate();
  const location= useLocation();
 const {messages} = useIntl()
  const updateStats = async (type) => {
    const statsRef = firebase.firestore().collection('stats')
    const stats = await statsRef.get()
    const data = stats.docs[0].data()
    const id = stats.docs[0].id
    data[type.toString()] =  data[type.toString()] + 1
    data.total = data.total + 1

    await statsRef.doc(id).update({...data})
  }
  const formInvestor = useFormik({
    initialValues: {
      links: [''],
    },
    validationSchema: Yup.object().shape({
      links: Yup.array().of(
        Yup.string('Any links you would like to share').url('link must be a valid url'))
          /*.matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/ , "Portfolio must be a valid url"),
      )*/
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true)
        await registerWithEmail(location?.state?.data?.email , location?.state?.data?.password);
        const user = firebase.auth().currentUser;
        user
          .sendEmailVerification({url: 'https://mogu-98cbd.web.app/auth/login'})
          .then()

        user.updateProfile({displayName: location?.state?.data?.name}).then();

        const usersRef = firebase.firestore().collection('users');
        // window.localStorage.setItem('user', JSON.stringify(user))
        delete  location?.state?.data?.password;
        // setUser(user);
        // setProfile({
        //   ...user,
        //   ...location?.state?.data
        // });
        delete  location?.state?.data?.password;
        const postObject =JSON.stringify( {
          uid: user.uid,
          ...location?.state?.data,
          organizationDetails: {...location?.state?.organizationDetails},
          aboutYourWork: {...values},
        })
        const id = await usersRef.add(
          {...JSON.parse(postObject),           createdAt: firebase.firestore.FieldValue.serverTimestamp()}
        );
        updateStats(location?.state?.data.userType)
        // setOpen(true)
        setLoading(false)
        // const doc = await usersRef.doc(id.id).get()
        // setProfile({
        //   ...doc.data(), id: id.id
        // });


        /*if (location.state.data.userType === 'creator' ) {
          navigator('/creator/membership-plan');
        }
        else if (location.state.data.userType === 'investor') {
          navigator('/investor/membership-plan');
          // window.location.reload(false)
        }
        else {
          navigator('/artists/membership-plan');
          // window.location.reload(false)
        }*/
      } catch (e) {
        setLoading(false)
        console.log(JSON.stringify(e), 'ERROR')
        
      }
      
    },
  })
  const formikCreator = useFormik({
    initialValues: {
      portfolio:'',
      imdb:'',
      other:'',
    },
    validationSchema: Yup.object({
      portfolio: Yup.string('Portfolio').url("Portfolio must be a valid url").required('Portfolio link *'),
      imdb: Yup.string('IMDB link').url("IMDB link must be a valid url").matches("imdb" , "Enter a valid imdb link"),
      other: Yup.string('Other important links').url("Other link must be a valid url"),
      // portfolio: Yup.string('Any links you would like to share').url("Portfolio must be a valid url").required('Portfolio link *'),
      // portfolio: Yup.string('Any links you would like to share').matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/ , "Portfolio must be a valid url").required('Portfolio link *'),
      // imdb: Yup.string('imdb').matches(/www.imdb.com/, "Please enter valid IMDb url").url("The link must be a valid url"),
      // imdb: Yup.string('IMDB link').matches(/((https?):\/\/)?(www.imdb.com)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/ , "Portfolio must be a valid url"),
      // other: Yup.string('Other important links').matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/ , "Portfolio must be a valid url"),
    }),
    onSubmit: async (values) => {
      console.log('OnSubmit::', JSON.stringify(values))

      try {
        setLoading(true)

        await registerWithEmail(location?.state?.data?.email , location?.state?.data?.password);
        const user = firebase.auth().currentUser;
        user
          .sendEmailVerification({url: 'https://mogu-98cbd.web.app/auth/login'})
          .then()

        user.updateProfile({displayName: location?.state?.data?.name}).then();
        const usersRef = firebase.firestore().collection('users');
        // window.localStorage.setItem('user', JSON.stringify(user))
        delete  location?.state?.data?.password;
        // setUser(user);
        // setProfile({
        //   ...user,
        //   ...location?.state?.data
        // });
        const postObject =JSON.stringify( {
          uid: user.uid,
          ...location?.state?.data,
          organizationDetails: {...location?.state?.organizationDetails},
          aboutYourWork: {...values},
        });
        updateStats(location?.state?.data.userType);
        const id = await usersRef.add(
          {...JSON.parse(postObject),           createdAt: firebase.firestore.FieldValue.serverTimestamp()}
        );
        // const doc = await usersRef.doc(id.id).get()
        // setProfile({
        //   ...doc.data(), id: id.id
        // });
        setLoading(false);

        /*if (location.state.data.userType === 'creator' ) {
          navigator('/creator/membership-plan');
        } else if (location.state.data.userType === 'investor') {
          navigator('/investor/membership-plan');
        }
        else {
          navigator('/artists/membership-plan');
        }*/
      } catch (e) {
        console.log(JSON.stringify(e), 'ERROR')
        setLoading(false)
      }
    }
  });
 if (loading) return <Spinner/>;
  return(
    <>
    <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar/>*/}
     {/* <Container  maxWidth="lg" component="main" sx={{ pt: 4, }}>
        <Typography variant="h3" align="center" color="text.primary" component="p">
          Logo
        </Typography>
      </Container>*/}
      <Stepper stepNumber={4}/>

      <Container  maxWidth="md" component="main" sx={{}}>
        <Box sx={{pl: 10, pr: 10 }}>
        <Typography variant="h4" align="left" color="text.primary" component="p">
          About your work
          {/*{messages?.joinNow?.create_new_account?.pageTitle}*/}
        </Typography>
            <Typography variant="body" align="left" color="text.primary" component="p" sx={{ margin: '20px 0px 40px 0px', }}>
              {messages?.joinNow?.create_new_account?.titleA}<br/>{messages?.joinNow?.create_new_account?.titleB}<Button variant="text" sx={{textDecoration: 'underline', fontWeight: 600, top: -2}} onClick={()=>navigator('/auth/login')}>{messages?.joinNow?.create_new_account?.signinButton}</Button>
            </Typography>
          </Box>
          
      </Container>
      {/* End hero unit */}
      <Container maxWidth="md" component="main" sx={{}}>
        <Grid container spacing={2}  sx={{pl: 10, pr: 10}}>
          <Grid item xs={12}>
            {(location.state.data.userType === 'creator' || location.state.data.userType === 'artist') &&
            <Box   component="form" onSubmit={formikCreator.handleSubmit} sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
              flexDirection:'column',
            }}
            >
              <Grid container spacing={2}>





                <Grid item xs={12}>
                  <TextField
                    name="portfolio"
                    label='Portfolio link'
                    value={formikCreator.values.portfolio}
                    onChange={formikCreator.handleChange}
                    onBlur={(e) => {
                      const value = e.target.value
                      if (value !== '') {
                        const checkValid = /https:\/\/|http:\/\//
                        if (!checkValid.test(value)) formikCreator.setFieldValue('portfolio', 'https://'+ value)
                      }
                    }}
                    error={formikCreator.touched.portfolio && Boolean(formikCreator.errors.portfolio)}
                    helperText={formikCreator.touched.portfolio && formikCreator.errors.portfolio}
                    variant="outlined" sx={{width:'100%'}}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="imdb"
                    label='IMDb link'
                    value={formikCreator.values.imdb}
                    onChange={formikCreator.handleChange}
                    error={formikCreator.touched.imdb && Boolean(formikCreator.errors.imdb)}
                    helperText={formikCreator.touched.imdb && formikCreator.errors.imdb}
                    onBlur={(e) => {
                      const value = e.target.value
                      if (value !== '') {
                        const checkValid = /https:\/\/|http:\/\//
                        if (!checkValid.test(value)) formikCreator.setFieldValue('imdb', 'https://'+ value)
                      }
                    }}
                    variant="outlined" sx={{width:'100%'}}/>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="other"
                    value={formikCreator.values.other}
                    onChange={formikCreator.handleChange}
                    error={formikCreator.touched.other && Boolean(formikCreator.errors.other)}
                    helperText={formikCreator.touched.other && formikCreator.errors.other}
                    label='Other important links'
                    onBlur={(e) => {
                      const value = e.target.value
                      if (value !== '') {
                        const checkValid = /https:\/\/|http:\/\//
                        if (!checkValid.test(value)) formikCreator.setFieldValue('other', 'https://'+ value)
                      }
                    }}
                    variant="outlined" sx={{width:'100%'}}/>
                </Grid>

                <Grid item xs={12}>
                  <div style={{width:'100%', margin: 'auto'}}>

                    <Typography variant="body" align="left" color="text.primary" component="p" sx={{ margin: '20px 0px'}}>
                      {messages?.joinNow?.create_new_account?.lastText}<Button variant="text" sx={{textDecoration: 'underline', fontWeight: 600, top: -2}} onClick={()=>navigator('/terms')}>{messages?.joinNow?.create_new_account?.termsOfService}</Button>
                    </Typography>
                  </div>
                </Grid>
                <Container  maxWidth="lg"  component="main" sx={{  }}>

                  <Stack spacing={5} direction="row" sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop:"20px",
                      marginBottom:"20px",
                  }}>
                    <Button variant="outlined" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,  textTransform:'capitalize',width:"180px"}}   onClick={() => navigator(-1)}>Go back</Button>

                    <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, textTransform:'capitalize',width:"180px"}} type={'submit'}>{messages?.joinNow?.create_new_account?.nextButton}</Button>
                  </Stack>
                </Container>
                <Container  maxWidth="lg"  component="main" sx={{ mt: '35px', mb: '20px'}}>
                  <div style={{backgroundColor: '#000', width: '100%', height:1,} }/>
                  <div style={{width: '75px', margin: 'auto', top: '-13px', position: 'relative'}}>
                    <Typography sx={{backgroundColor: '#fff', }}>
                      {messages?.joinNow?.create_new_account?.OR}
                    </Typography>
                  </div>
                </Container>
               
              </Grid>

            </Box>
            }


            {
              location.state.data.userType === 'investor' &&
              <FormikProvider value={formInvestor}>
                <Box   component="form" onSubmit={formInvestor.handleSubmit} sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mb: 2,
                  flexDirection:'column',
                }}
                >
                  <Grid container spacing={2}>





                    <Grid item xs={12}>
                      <FieldArray name={'links'}  render={(arrayHelpers) => {

                        return (<>
                          {arrayHelpers?.form.values.links.map((p, i) => (
                            <Box key={i}  sx={{mb: 5}}>
                              {arrayHelpers?.form.values.links.length > 1 &&

                              <Button variant={'outlined'} color={'error'} startIcon={<CloseIcon />} onClick={() => arrayHelpers.remove(i)} sx={{float:'right', borderRadius:0}}>
                                Remove
                              </Button>

                              }
                              <Grid container spacing={3}>

                                <Grid item xs={12} >
                                  <TextField
                                    name={`links.${i}`}
                                    label='Any links you would like to share'
                                    value={formInvestor.values.links[i]}
                                    onChange={formInvestor.handleChange}
                                    onBlur={(e) => {
                                      debugger
                                      const value = e.target.value
                                      if (value !== '') {
                                        const checkValid = /https:\/\/|http:\/\//
                                        if (!checkValid.test(value)) formInvestor.setFieldValue(`links.${i}`, 'https://'+ value)
                                      }
                                    }}
                                    error={(formInvestor.touched && formInvestor.touched.links !== undefined &&  formInvestor.errors.links !== undefined) && formInvestor.touched.links[i] && Boolean(formInvestor.errors.links[i])}
                                    helperText={((formInvestor.touched && formInvestor.touched.links !== undefined &&  formInvestor.errors.links !== undefined) && formInvestor.touched.links[i] && formInvestor.errors.links[i])? "Please Provide a Valid URL" : ""}
                                    variant="outlined" sx={{width:'100%'}} />
                                </Grid>

                                <Grid item sx={12}>
                                  {arrayHelpers?.form.values.links.length - 1 === i}
                                  {arrayHelpers?.form.values.links.length - 1 === i&&

                                  <Button variant={'outlined'} sx={{borderRadius: 0}} startIcon={<AddIcon />} onClick={() => arrayHelpers.push('')}>Add another</Button>
                                  }
                                </Grid>
                              </Grid>
                            </Box>
                          ))}
                        </>)
                      }

                      }/>
                    </Grid>



                    <Grid item xs={12}>
                      <div style={{width:'100%', margin: 'auto'}}>

                        <Typography variant="body" align="left" color="text.primary" component="p" sx={{ margin: '20px 0px'}}>
                          {messages?.joinNow?.create_new_account?.lastText}<Button variant="text" sx={{textDecoration: 'underline', fontWeight: 600, top: -2}} onClick={()=>navigator('/terms')}>{messages?.joinNow?.create_new_account?.termsOfService}</Button>
                        </Typography>
                      </div>
                    </Grid>
                    <Container  maxWidth="lg"  component="main" sx={{  }}>

                      <Stack spacing={5} direction="row" sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                        <Button variant="outlined" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,  textTransform:'capitalize',width:"180px"}}   onClick={() => navigator(-1)}>Go back</Button>

                        <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, textTransform:'capitalize',width:"180px"}} type='submit' >{messages?.joinNow?.create_new_account?.nextButton}</Button>
                      </Stack>
                    </Container>
                    <Container  maxWidth="lg"  component="main" sx={{ mt: '35px', mb: '20px'}}>
                      <div style={{backgroundColor: '#000', width: '100%', height:1,} }/>
                      <div style={{width: '75px', margin: 'auto', top: '-13px', position: 'relative'}}>
                        <Typography sx={{backgroundColor: '#fff', }}>
                          {messages?.joinNow?.create_new_account?.OR}
                        </Typography>
                      </div>
                    </Container>
            


                  </Grid>
                </Box>
              </FormikProvider>
            }


          </Grid>
         
            <Container  maxWidth="lg"  component="main" sx={{  }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                    <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0"  }} startIcon={<img src="/assets/imdb.png" style={{height: 25 ,  color: "#a0a0a0"}} alt="imdb "/>} disabled={true}>
                                            IMDb
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>

                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Twitter.png" style={{height: 25 }} alt="twitter "/>} disabled={true}>
                                                Twitter
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Linkedin.png" style={{height: 25 }} alt="linkedin"/>} disabled={true}>
                                                Linkedin
                                            </Button>
                    </Grid>

                  </Grid>
                </Container>
        </Grid>
      </Container>




    </>
  )
}
